<template>
  <div>
    <b-container class="mt-4 mb-4">
      <div class="col-md-12 mt-4 d-flex align-items-start">
        <back-arrow :title="$t('Menu.my.alerts')"/>
        <b-button class="ml-auto" variant="primary" @click="goToSearch">{{ $t('saved.search.a.create') }}</b-button>
      </div>

      <transition-group v-if="isLoading" appear name="listCustomTransition" tag="div">
        <div key="homePlaceHolder-draft" class="mt-4">
          <div class="other-annonces card-container row row-cards-annonces">
            <PlaceholderCardAlerts :isAnimated=true :isGradient=false></PlaceholderCardAlerts>
            <PlaceholderCardAlerts :isAnimated=true :isGradient=false></PlaceholderCardAlerts>
            <PlaceholderCardAlerts :isAnimated=true :isGradient=false></PlaceholderCardAlerts>
            <PlaceholderCardAlerts :isAnimated=true :isGradient=false></PlaceholderCardAlerts>
          </div>
        </div>
      </transition-group>

      <transition-group v-if="!isLoading" name="listCustomTransition">
        <template v-if="myAlerts.length > 0">
          <div v-for="(alert, index) in myAlerts" :key="index+'-alert'" class="mt-2 alert-container">
            <div class="d-flex justify-content-between align-items-center alert-header">
              <h1 class="page-subtitle cursor-pointer" @click="redirectToAlertAnnonce(alert.id,alert.name)">
                {{ alert.name }}</h1>
              <b-icon class="delete-icon" icon="trash" variant="danger" @click="deleteAlert(alert.id)"></b-icon>
            </div>
            <div v-if="alert.description" class="mt-2 main-grey-medium-color alert-description">
              {{ $t('annonce.home.savedSearch.with.filters') }} {{ alert.description }}
            </div>
          </div>
        </template>
        <template v-else>
          <div key="favorites-empty-list" class="mt-2">
            <div class="d-flex">
              <div class="p-3">
                <img :src="require(`@/assets/images/b122/img-confused.png`)" alt="no result"
                     class="empty-state-img-home">
              </div>
              <div class="empty-state-text">
                {{ $t('my.alerts.empty.state.description') }}
              </div>
            </div>
          </div>

        </template>
      </transition-group>
    </b-container>

    <delete-saved-search-modal :selected-item="savedSearchId" :selected-item-name="savedSearchName"
                               begins-with-voyel
                               item-to-string="alerte"
                               the-article="l'"
                               @didDeleteItem="didDeleteAlert"></delete-saved-search-modal>

  </div>


</template>

<script>
import api from '../../services/api'
import ShowActions from '../../components/b122/ShowActions.vue'
import BackArrow from '../../components/b122/BackArrow.vue'
import PlaceholderCardAlerts from "./PlaceholderCardAlerts";
import DeleteSavedSearchModal from "../search/DeleteSavedSearchModal";
import {eventBus} from "../../main";

export default {
  name: 'MyAlerts',
  components: {BackArrow, ShowActions, PlaceholderCardAlerts, DeleteSavedSearchModal},

  data() {
    return {
      userId: this.$store.getters.userId,
      user: {},
      myAlerts: [],
      isLoading: true,
      savedSearchId: null,
      savedSearchName: null
    }
  },

  mounted() {
    this.fetchData()
  },

  methods: {
    async fetchData() {
      await this.fetchMyAnnonce()
    },

    async fetchMyAnnonce() {
      api({
        method: "GET",
        url: '/savedSearch/getMyAlerts',
      })
        .then(async (response) => {
          this.myAlerts = response.data
          this.isLoading = false
        })
    },

    didDeleteAlert(alertId) {
      this.myAlerts = this.myAlerts.filter(alert => alert.id !== alertId);
    },


    async deleteAlert(alertId, alertName) {
      this.savedSearchId = alertId
      this.savedSearchName = alertName
      this.$bvModal.show('delete-saved-search-modal')
    },

    emptyStateText(annonceType) {
      if (annonceType === 'DRAFT') {
        return "annonce.mine.emptyText.draft"
      }
      if (annonceType === 'VALIDATED') {
        return "annonce.mine.emptyText.validated"
      }
      if (annonceType === 'TO_VALIDATE') {
        return "annonce.mine.emptyText.to.validate"
      }
      return ""
    },

    redirectToAlertAnnonce(alertId, alertName) {
      this.$router.push({
        name: 'Search',
        params: {
          annonceType: "SAVED_SEARCH_ANNONCES",
          savedSearchId: alertId,
          savedSearchName: alertName
        }
      })
    },

    goToSearch() {
      if (this.$store.state.identityToSubmit) {
        eventBus.$emit('checkIdentityValidation')
      } else {
        this.$router.push({
          name: 'Search',
          params: {
            fromBtnName: "filters",
            filtersData: null,
          }
        })
      }
    },
  },
}
</script>

<style scoped>
.alert-container {
  padding: 1em 0;

}

.alert-container:not(:last-child) {
  border-bottom: 1px solid var(--main-grey-light);
}

.alert-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.page-subtitle {
  color: var(--main-yellow-medium);
  font-family: KumbhSans-Regular, Arial, sans-serif;
  margin: 0;
  font-weight: 700;
  letter-spacing: 1px;
}

.delete-icon {
  cursor: pointer;
  font-size: 1.5rem;
  color: var(--main-yellow-medium);
}

.delete-icon:hover {
  color: var(--main-yellow-dark);
}

.alert-description {
  color: var(--main-grey-medium);
  margin-top: 10px;
}

.cards-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.card-container {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
  margin-right: -5px;
  margin-left: -5px;
}

.other-annonces .card-inside-container {
  margin-top: 0.5em;
  flex: 1 1 auto;
  min-width: 250px;
  width: 25%;
  max-width: 25%;
  padding-right: 5px;
  padding-left: 5px;
}

.last-annonces .card-inside-container {
  margin-top: 0.5em;
  flex: 1 0 auto;
  min-width: 300px;
  width: 25%;
  max-width: 25%;
  padding-right: 5px;
  padding-left: 5px;
}

.other-annonces .card {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.empty-state-text {
  margin-top: 3.5rem;
  max-width: 300px;
}

.row-cards-annonces {
  margin-right: 0.5em;
  margin-top: 0.5em;
  margin-left: -0.5em;
}

@media (max-width: 768px) {
  .other-annonces .card-inside-container,
  .last-annonces .card-inside-container {
    width: 100% !important;
    max-width: 100% !important;
  }
}

@media (max-width: 991px) {
  .other-annonces .card-inside-container,
  .last-annonces .card-inside-container {
    width: 50%;
    max-width: 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/user/MyAlerts.vue